import React, { useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Header from "../../../policy/fragments/heading/index";
import { Link } from "react-router-dom";
import { useStore, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../hooks/common";
import { Iconfont } from "../../../../components/icon/iconfont";
import { useIntl } from "react-intl";
import MeSkeleton from "../home/skeleton/index";

import PointsMessage from "./fragments/points-message";
import GetPoints from "./fragments/get-points";
import PointsRecommend from "./fragments/points-recommend";


const Credits = props =>{
    useStyles(cls);
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const { customer } = useSelector(state => state.pageCustomer);
    const Intl = useIntl();

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
			await Credits.fetchData(store, params, query)
		}
    }, [customer?.id])


    return <div className={cls.Credits}>
        {
            customer?.id ? <React.Fragment>
                <Header 
                    centerSlot={Intl.formatMessage({ id: "my_points", defaultMessage: "My Points" })} 
                    rightSlot={
                        <a href="/policy/bonus-point" className={cls.RightIcon}>
                            <Iconfont className={cls.Icon}>&#xe73f;</Iconfont>
                        </a>
                    }
                />

                <PointsMessage customer={customer} />
                <GetPoints customer={customer} />
                <PointsRecommend customer={customer} />
            </React.Fragment> : <MeSkeleton />
        }
    </div>
}

Credits.fetchData = async (store, params, search, headers) => {
}

export default Credits;